import axios from "axios";
import { endpointApi } from "../../utils";
import { INVOICE_LIST_FAIL, INVOICE_LIST_REQUEST, INVOICE_LIST_SUCCESS, INVOICE_LIST_UPDATE } from "../constats/invoice.constant";
import { logout } from "./auth.action";

export const getInvoices = (location=null, navigate=null) => async(dispatch) => {
    try {
        const jwt_access = localStorage.getItem('jwt_access');
        dispatch({
            type: INVOICE_LIST_REQUEST
        });
        const { data } = await axios.get(`${ endpointApi }invoices${ location ? location.search : "" }`, {
            headers: {
                'Authorization': `Bearer ${ jwt_access }`
            }
        });
        dispatch({
            type: INVOICE_LIST_SUCCESS,
            payload: data
        });
    } catch (err) {
        if(err.response.status === 401){
            dispatch({
                type: INVOICE_LIST_FAIL,
                payload: null
            });
            const url = location ? location.pathname + location.search : null;
            dispatch(logout(url, navigate));
        }else{
            dispatch({
                type: INVOICE_LIST_FAIL,
                payload: err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message
            });
        }
    }
}

export const changeElementInList = (invoice) => async(dispatch) => {
    dispatch({
        type: INVOICE_LIST_UPDATE,
        payload: invoice
    })
}